export const TWILIO_NETWORK_QUALITY_STATS_CLASS_NAME = 'NetworkQualityStats2';
